import { useTenantIdFromParams } from '@eluve/session-helpers';
import { useExternalEhrs } from '@eluve/smart-blocks';

export const useFirstAvailableEhr = () => {
  const tenantId = useTenantIdFromParams();
  const externalEhrs = useExternalEhrs(tenantId!);
  const firstAvailableEhr = externalEhrs[0];
  return firstAvailableEhr ?? null;
};
